<template>
  <div v-if="isCriteriaFloconVert || isCriteriaCleVerte">
    <div class="responsible-stay-card d-flex flex-column flex-md-row align-items-start align-items-md-center gap-3 p-3 bg-white border border-primary-green rounded-custom">
      <!-- Desktop Icon -->
      <div class="desktop-icon d-none d-md-flex justify-content-center align-items-center rounded-circle bg-green-200" style="min-width: 71px; height: 71px;">
        <svg class="d-icon">
          <use xlink:href="#___icon___responsible"></use>
        </svg>
      </div>

      <!-- Content Wrapper -->
      <div class="content-wrapper d-flex flex-column align-items-start gap-2 text-md-left">
        <!-- Title and Mobile Icon -->
        <div class="d-flex align-items-center gap-2">
          <div class="mobile-icon d-flex d-md-none justify-content-center align-items-center rounded-circle bg-green-200" style="width: 30px; height: 30px;">
            <svg class="m-icon">
              <use xlink:href="#___icon___responsible"></use>
            </svg>
          </div>
          <strong class="title-4 text-primary-green mb-0">
            {{ content.responsible_stay }}
          </strong>
        </div>
        <!-- Description -->
        <p class="body m-0">
          {{ content.responsible_stay_hover }}
        </p>
      </div>

      <!-- Button -->
      <button class="button-secondary-small ms-auto" @click.stop="togglePopup">
        {{ content.productDesc_seeMore }}
      </button>
    </div>

    <!-- Extracted Popup Component -->
    <EcoPopup
      :isOpen="isPopupOpen"
      :title="content.responsible_stay"
      :isCriteriaFloconVert="isCriteriaFloconVert"
      :isCriteriaCleVerte="isCriteriaCleVerte"
      @close="closePopup"
    />
  </div>
</template>


<script setup lang="ts">
  import { ref, watch } from 'vue'
  import EcoPopup from '@/vue/responsible-stay/components/EcoPopup.vue'
  import { CriteriaEnum } from '@/enums/criterias'

  interface IResponsibleStay {
    stationData: Record<string, any>
  }

  const props = defineProps<IResponsibleStay>()

  const content = ref<{ [key: string]: string }>(window.content)
  const isCriteriaFloconVert = ref(false)
  const isCriteriaCleVerte = ref(false)
  const isPopupOpen = ref(false)

  const checkCriteria = (): void => {
    if (props.stationData?.criterias) {
      isCriteriaFloconVert.value = props.stationData.criterias.includes(
        CriteriaEnum.FLOCON_VERT
      )
    }
    if (window.lihe?.criteriasList) {
      isCriteriaCleVerte.value = window.lihe.criteriasList.includes(
        CriteriaEnum.CLE_VERTE
      )
    }
  }

  watch(
    () => props.stationData?.criterias,
    newCriterias => {
      if (newCriterias) {
        checkCriteria()
      }
    }
  )

  const togglePopup = () => {
    isPopupOpen.value = !isPopupOpen.value
  }

  const closePopup = () => {
    isPopupOpen.value = false
  }
</script>

<style scoped>
  /* Custom Styles */
  .d-icon {
    width: 44px;
    height: 44px;
  }

  .m-icon {
    width: 20px;
    height: 20px;
  }

  .rounded-custom {
    border-radius: 1rem;
  }

  .title-4 {
    color: #005f32;
  }

</style>
